var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.5H1.5C0.671574 2.5 0 3.17157 0 4V12.5C0 13.3284 0.671574 14 1.5 14H10C10.8284 14 11.5 13.3284 11.5 12.5V4C11.5 3.17157 10.8284 2.5 10 2.5ZM10.5 12.5C10.5 12.7762 10.2762 13.0001 10 13.0001H1.5C1.22385 13.0001 0.999992 12.7762 0.999992 12.5V4C0.999992 3.72385 1.22385 3.49999 1.5 3.49999H10C10.2762 3.49999 10.5 3.72385 10.5 4V12.5Z",
    fill: "#200E32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0H3.5C2.67157 0 2 0.671574 2 1.5C2 1.77616 2.22386 2.00001 2.50001 2.00001C2.77616 2.00001 2.99999 1.77616 2.99999 1.5C2.99999 1.22385 3.22385 0.999992 3.5 0.999992H12.5C12.7762 0.999992 13 1.22385 13 1.5V10.5C13 10.7762 12.7762 11 12.5 11C12.2239 11 12 11.2239 12 11.5C12 11.7762 12.2239 12.0001 12.5 12.0001C13.3285 12.0001 14 11.3285 14 10.5001V1.5C14 0.671574 13.3285 0 12.5 0Z",
    fill: "#200E32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.1fd151f648d1934e8afae0689dc80c91.svg";
export { ForwardRef as ReactComponent };